class serviceEnv {
    config = {
        environment: '',
        environmentDescLong: '',
        websiteUrl: '',
        serviceUrl: '',
        serviceKey: '',
        serviceId: '',
        servicePortfolioElement: '',
        serviceInfoObjectVersion: '',
        serviceInfoObjectEncryptionLevel: '',
        serviceInfoObjectEncryptionKey: '',
        awsS3Region: '',
        awsS3IdentityPoolId: '',
        awsS3Bucket: '',
    };
    _configDev = {
        environment: 'DEV',
        environmentDescLong: 'Development',
        websiteUrl: 'http://dev.iammounir.com',
        serviceUrl: 'https://e00007-dev.stina-global.com',
        serviceKey: '77bb8381-c6ce-4b92-8150-04a0fc4f0025',
        serviceId: '9a85fa15-a135-4b41-8219-4c38f73beaae',
        servicePortfolioElement: 'p00017',
        serviceInfoObjectVersion: '1-0-1',
        serviceInfoObjectEncryptionLevel: '0',
        serviceInfoObjectEncryptionKey: '0',
        awsS3Region: '',
        awsS3IdentityPoolId: '',
        awsS3Bucket: '',
    };
    _configTest = {
        environment: 'TEST',
        environmentDescLong: 'Test',
        websiteUrl: 'http://test.iammounir.com',
        serviceUrl: 'https://e00007-test.stina-global.com',
        serviceKey: '77bb8381-c6ce-4b92-8150-04a0fc4f0025',
        serviceId: '9a85fa15-a135-4b41-8219-4c38f73beaae',
        servicePortfolioElement: 'p00017',
        serviceInfoObjectVersion: '1-0-1',
        serviceInfoObjectEncryptionLevel: '0',
        serviceInfoObjectEncryptionKey: '0',
        awsS3Region: '',
        awsS3IdentityPoolId: '',
        awsS3Bucket: '',
    };
    _configProd = {
        environment: 'PROD',
        environmentDescLong: 'Production',
        websiteUrl: 'http://www.iammounir.com',
        serviceUrl: 'https://e00007.stina-global.com',
        serviceKey: '77bb8381-c6ce-4b92-8150-04a0fc4f0025',
        serviceId: '9a85fa15-a135-4b41-8219-4c38f73beaae',
        servicePortfolioElement: 'p00017',
        serviceInfoObjectVersion: '1-0-1',
        serviceInfoObjectEncryptionLevel: '0',
        serviceInfoObjectEncryptionKey: '0',
        awsS3Region: '',
        awsS3IdentityPoolId: '',
        awsS3Bucket: '',
    };
    _configLocal = {
        environment: 'LOCAL',
        environmentDescLong: 'Local Development',
        websiteUrl: 'http://dev.iammounir.com',
        serviceUrl: 'http://localhost:8080',
        serviceKey: '77bb8381-c6ce-4b92-8150-04a0fc4f0025',
        serviceId: '9a85fa15-a135-4b41-8219-4c38f73beaae',
        servicePortfolioElement: 'p00017',
        serviceInfoObjectVersion: '1-0-1',
        serviceInfoObjectEncryptionLevel: '0',
        serviceInfoObjectEncryptionKey: '0',
        awsS3Region: '',
        awsS3IdentityPoolId: '',
        awsS3Bucket: '',
    };
    constructor() {
        const browserWindow = window || {};
        const browserWindowEnv = browserWindow['__env'] || {};

        if (Object.prototype.hasOwnProperty.call(browserWindowEnv, 'appEnvironment')) {
            this.setEnv(browserWindowEnv['appEnvironment']);
        }
    }
    setEnv(appEnvironment) {
        if (appEnvironment === 'production') {
            this.config = this._configProd;
        } else if (appEnvironment === 'test') {
            this.config = this._configTest;
        } else if (appEnvironment === 'development') {
            this.config = this._configDev;
        } else {
            this.config = this._configLocal;
        }
    }
}

export default new serviceEnv();